// CreateProfileDialog.tsx
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { useRouter } from 'next/navigation';
import React from 'react';
import { useTranslate } from 'src/locales';
import { paths } from 'src/routes/paths';

type CreateProfileDialogProps = {
  open: boolean;
  onClose: () => void;
};

export const CreateProfileDialog = ({ open, onClose }: CreateProfileDialogProps) => {
  const router = useRouter();
  const { t } = useTranslate('connect'); // Destructure the t function for translations

  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <DialogTitle>{t('completeProfile.title')}</DialogTitle>{' '}
      <DialogContent>{t('completeProfile.content')}</DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={() => router.replace(`${paths.auth.editProfile}`)}>
          {t('completeProfile.yes')}
        </Button>
        <Button variant="outlined" onClick={onClose}>
          {t('completeProfile.no')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
